import { lazy } from 'react';

export const FileUploadDropzone = lazy(() =>
  import('./FileUploadDropzone').then((m) => ({ default: m.FileUploadDropzone }))
);

export const ParsingStatus = lazy(() =>
  import('./ParsingStatus').then((m) => ({ default: m.ParsingStatus }))
);

export const ValidationSummary = lazy(() =>
  import('./ValidationSummary').then((m) => ({ default: m.ValidationSummary }))
);

export const ValidRowsTable = lazy(() =>
  import('./ValidRowsTable').then((m) => ({ default: m.ValidRowsTable }))
);

export const InvalidRowsTable = lazy(() =>
  import('./InvalidRowsTable').then((m) => ({ default: m.InvalidRowsTable }))
);

export const DuplicatesTable = lazy(() =>
  import('./DuplicatesTable').then((m) => ({ default: m.DuplicatesTable }))
);

export const ImportActions = lazy(() =>
  import('./ImportActions').then((m) => ({ default: m.ImportActions }))
);

export const ImportProgress = lazy(() =>
  import('./ImportProgress').then((m) => ({ default: m.ImportProgress }))
);
